;(function (angular) {
  'use strict'

  angular.module('kilo.routes.payment', [
    'kilo.routes.payment.list'
  ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  /**
   *
   */
  function RouteConfigurator ($stateProvider) {
    //
    var parentState = {
      name: 'payment',
      url: '/payment',
      abstract: true
    }

    //
    $stateProvider.state(parentState)
  }
})(window.angular)
